import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Reusable password input with a show/hide eye toggle.
 *
 * Preserves all existing <input> props (value/onChange/placeholder/name/etc.).
 * A per-instance `testId` prop auto-generates:
 *   - {testId}         → input
 *   - {testId}-toggle  → eye button
 * If not provided, the button gets a fallback testid "password-toggle".
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", inputClassName = "", testId, ...rest }, ref
) {
  const [show, setShow] = useState(false);
  const inputTestId = testId || rest["data-testid"];
  const toggleTestId = inputTestId ? `${inputTestId}-toggle` : "password-toggle";
  return (
    <div className={`relative ${className}`}>
      <input
        ref={ref}
        {...rest}
        type={show ? "text" : "password"}
        data-testid={inputTestId}
        className={`${inputClassName} ${inputClassName?.includes("pl-") ? "" : "pl-10"}`.trim()}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
        data-testid={toggleTestId}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)] hover:text-primary-brand transition-colors p-1"
      >
        {show ? <EyeOff size={16}/> : <Eye size={16}/>}
      </button>
    </div>
  );
});

export default PasswordInput;
